/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListReposRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/**
 * The org's repositories.
 */
export type ListReposResponseBody = {
  repos: Array<components.Repo>;
};

/** @internal */
export const ListReposRequest$inboundSchema: z.ZodType<
  ListReposRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListReposRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListReposRequest$outboundSchema: z.ZodType<
  ListReposRequest$Outbound,
  z.ZodTypeDef,
  ListReposRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listReposRequestToJSON(
  listReposRequest: ListReposRequest,
): string {
  return JSON.stringify(
    ListReposRequest$outboundSchema.parse(listReposRequest),
  );
}
export function listReposRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListReposRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListReposRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListReposRequest' from JSON`,
  );
}

/** @internal */
export const ListReposResponseBody$inboundSchema: z.ZodType<
  ListReposResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  repos: z.array(components.Repo$inboundSchema),
});
/** @internal */
export type ListReposResponseBody$Outbound = {
  repos: Array<components.Repo$Outbound>;
};

/** @internal */
export const ListReposResponseBody$outboundSchema: z.ZodType<
  ListReposResponseBody$Outbound,
  z.ZodTypeDef,
  ListReposResponseBody
> = z.object({
  repos: z.array(components.Repo$outboundSchema),
});

export function listReposResponseBodyToJSON(
  listReposResponseBody: ListReposResponseBody,
): string {
  return JSON.stringify(
    ListReposResponseBody$outboundSchema.parse(listReposResponseBody),
  );
}
export function listReposResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListReposResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListReposResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListReposResponseBody' from JSON`,
  );
}
